/*
This file is located in the main branch
Last time the file was updated (UTC): [02.07.2024 18:52:57]
Permissions to update outside the main branch: [false]
*/

import { DropdownFilterButton } from '@finbeat/react-toolkit';
import { faPlus } from '@fortawesome/free-solid-svg-icons';
import { useBrandWorkplaceState } from './Brands';

type BrandAddButtonProps = {
    showModal: () => void;
};

const BrandAddButton = ({ showModal }: BrandAddButtonProps) => {
    const { setSelectedItem: setCurrentItem } = useBrandWorkplaceState();

    return (
        <DropdownFilterButton
            onClick={() => {
                setCurrentItem(null);
                showModal();
            }}
            icon={faPlus}
            disabled={false}
            title="BackOfficeAdd"
        />
    );
};

export default BrandAddButton;
